import React, { useEffect, useState } from 'react';
import { Hidden } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { PageContainer } from '../../../../../global/components/layout/page-container';
import { MainContent } from '../../../../../global/components/layout/main-content-container';
import { SearchApp } from '../../../../../search/components/search-app';
import { sortTableStyles } from '../../../../../global/constants/theme/styles/tables/generic-sort-table';
import { SearchList } from '../../../../../search/components/search-list';
import { ListPagination } from '../../../../../search/components/list-pagination';
import { InstitutionProps, SearchProps } from '../../../models/arc-epi-props';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { PensionPlanDetail, PensionPlanTypes } from './plan-history-models';
import { getDcPlanDetail, getRsvpPlanDetail } from '../../../../../global/ducks/benadmin-api';
import { AmendmentHistoryLabels } from './amendment-history-labels';
import { TerminationHistoryLabels } from './terminated-history-labels';
import { AmendmentHistoryView } from './amendment-history-view';
import { TerminationHistoryView } from './termination-history-view';

interface Props {
	activePlanId: number;
	terminatedPlanId: number;
	planType: PensionPlanTypes;
}

function DcRsvpPlanHistory(props: Props) {

	const { activePlanId, terminatedPlanId, planType } = props;
	const settings = useSelector<TcsmStates, InstitutionProps>(state => state.epiProps?.institutionSettingsState?.epiContent);
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps?.searchSettingsState?.epiContent);
	const institutionId = useSelector<TcsmStates, string>(state => state.institutionState?.currentInstitution?.org_client_nbr);
	const tableClasses = sortTableStyles();
	const [amendmentHistory, setAmendmentHistory] = useState<PensionPlanDetail>(null);
	const [terminationHistory, setTerminationHistory] = useState<PensionPlanDetail>(null);
	const dispatch = useDispatch();
	useEffect(() => {

		switch (planType) {
			case PensionPlanTypes.LayDc:
				if (activePlanId) dispatch(getDcPlanDetail(institutionId, activePlanId, (res) => setAmendmentHistory(res?.data)));
				if (terminatedPlanId) dispatch(getDcPlanDetail(institutionId, terminatedPlanId, (res) => setTerminationHistory(res?.data)));
				break;
			case PensionPlanTypes.Rsvp:
				if (activePlanId) dispatch(getRsvpPlanDetail(institutionId, activePlanId, (res) => setAmendmentHistory(res?.data)));
				if (terminatedPlanId) dispatch(getRsvpPlanDetail(institutionId, terminatedPlanId, (res) => setTerminationHistory(res?.data)));
				break;
			default:
				break;
		}
	}, [activePlanId, terminatedPlanId]);


	return (

		<PageContainer>
			<MainContent fullWidth>
				<PageHeader
					headerText={settings?.planHistoryTitle}
				/>
				<ContentSpacer>
					<h3>{amendmentHistory?.name}</h3>
				</ContentSpacer>
				{
					amendmentHistory?.history &&
					<SearchApp initialList={amendmentHistory?.history} appName={activePlanId?.toString()} >
						<ContentSpacer>
							<h3>{settings?.amendmentHistoryTitle}</h3>
						</ContentSpacer>
						<div className={tableClasses.sortTable}>
							<Hidden xsDown>
								<AmendmentHistoryLabels settings={settings} />
							</Hidden>
							<div className='sort-table-content'>
								<SearchList
									renderList={
										(item) => {
											return <AmendmentHistoryView item={item} settings={settings} />;
										}
									}
									renderPagination={
										(totalCounts, name) => {
											return <ListPagination name={name} totalCounts={totalCounts} totalPages={Math.ceil(totalCounts / 10)} nextButton={searchSettings?.nextButton} prevButton={searchSettings?.previousButton} />;
										}
									}
									emptyMessage=''
								/>
							</div>
						</div>
					</SearchApp>
				}
				{
					terminationHistory?.history &&
					<SearchApp initialList={terminationHistory?.history} appName={terminatedPlanId?.toString()} >
						<ContentSpacer>
							<h3>{settings?.terminationHistoryTitle}</h3>
						</ContentSpacer>
						<div className={tableClasses.sortTable}>
							<Hidden xsDown>
								<TerminationHistoryLabels settings={settings} />
							</Hidden>
							<div className='sort-table-content'>
								<SearchList
									renderList={
										(item) => {
											return <TerminationHistoryView item={item} settings={settings} />;
										}
									}
									renderPagination={
										(totalCounts, name) => {
											return <ListPagination name={name} totalCounts={totalCounts} totalPages={Math.ceil(totalCounts / 10)} nextButton={searchSettings?.nextButton} prevButton={searchSettings?.previousButton} />;
										}
									}
									emptyMessage=''
								/>
							</div>
						</div>
					</SearchApp>
				}
			</MainContent>

		</PageContainer>

	);
}

export default DcRsvpPlanHistory;